<template>
  <v-app id="inspire" v-if="isAppReadyForUser">
    <v-layout>
      <v-navigation-drawer
        color="primary"
        width="256"
        :style="{ borderWidth: '0' }"
        permanent
      >
        <v-col style="height: 64px">
          <img
            :src="require('@/assets/JAMB-logo-white.svg')"
            height="40px"
          />
        </v-col>
        <template v-if="environment !== 'prod'">
          <v-col><h3>{{ environment }}</h3></v-col>
        </template>
      <!--
        The badge is whatever the chrome response says it is, rendered only when there is one.
        The client composes no nav text of its own, so a label like "Beta" is set and unset
        server-side alongside the title it qualifies.
      -->
      <v-list-item
        v-for="item in primaryNav"
        :key="item.url"
        :title="item.title"
        @click="nav(item.url)"
      >
        <template v-slot:append v-if="item.badge">
          <v-chip size="x-small" variant="tonal" label>{{ item.badge }}</v-chip>
        </template>
      </v-list-item>

        <!-- <template v-if="environment !== 'prod'">
                <v-col><h3>{{ environment }}</h3></v-col>
            </template>
      <v-list-item title="Owners" @click="nav('/owners')"> </v-list-item>
      <v-list-item 
        title="Contractors" 
        @click="nav('/contractors')"
        > 
      </v-list-item> -->
      </v-navigation-drawer>

      <v-app-bar color="primary" elevation="0">

        <Breadcrumbs></Breadcrumbs>
        
        <template v-slot:append>
          <v-menu>
            <template v-slot:activator="{ props }">
              <v-btn icon v-bind="props">
                <v-icon>mdi-account-circle</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="logout">
                <v-list-item-title
                  ><v-icon icon="mdi-logout"></v-icon> Sign
                  out</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-app-bar>

      <v-main>
        <v-container fluid>

          <RouterView></RouterView>
          <!-- <DashboardView v-if="isHome"></DashboardView> -->

          <v-dialog v-model="confirmAction" max-width="800">
            <v-overlay
              contained
              class="d-flex align-center justify-center"
              v-model="confirmOverlay"
            >
              <v-progress-circular
                :size="100"
                color="red"
                indeterminate
              ></v-progress-circular>
            </v-overlay>

            <v-card>
              <v-card-title>Confirm you want to {{ action }}</v-card-title>
              <v-card-text>
                <div v-if="compoundNotice != ''" class="text-caption">
                  {{ compoundNotice }}
                </div>
                <div style="margin-left: 30px" v-html="confirmText"></div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="ConfirmTrue()">Yes</v-btn>
                <v-btn @click="confirmAction = false">No</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="logNewBug" width="auto">
            <v-card max-width="600" title="Submit a support request">
              <template v-slot:actions>
                <v-btn
                  @click="submitBug()"
                  >Submit
                </v-btn>
                <v-btn
                  text="Cancel"
                  @click="logNewBug = false"
                ></v-btn>
              </template>
              <v-container>
                <v-form ref="form">
                  <v-row>
                    <v-col>
                      <!-- The type is what makes "number and type of support requests"
                           answerable in the monthly performance report. -->
                      <v-select
                        label="Request Type"
                        v-model="bugType"
                        :items="supportRequestTypes"
                        variant="filled"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-textarea
                        label="Description"
                        v-model="bugDescription"
                        variant="filled"
                        auto-grow
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card>
          </v-dialog>

          <v-snackbar
            v-model="appNotice.show"
            :color="appNotice.color"
            dismissible
            prominent
            :timeout="appNotice.timeout"
            transition="scale-transition"
            align="right"
          >
            <div v-html="appNotice.message"></div>
            <template v-slot:actions>
              <v-btn
                density="compact"
                variant="text"
                elevation="0"
                icon="mdi-window-close"
                @click="appNotice.show = false"
              ></v-btn>
            </template>
          </v-snackbar>
        </v-container>
      </v-main>
    </v-layout>
  </v-app>

  <v-container v-if="!isAppReadyForUser" align="center" fluid justify="center">
    <v-progress-circular
      color="primary"
      indeterminate
      :size="48"
      :width="6"
      style="height: 100vh"
    ></v-progress-circular>
  </v-container>
</template>

<script>
import Breadcrumbs from "@/components/interface/AppBreadcrumbs.vue";
// import DashboardView from "@/components/dashboard/OwnerAdmin.vue";
import "@aws-amplify/ui-vue/styles.css";
import { Hub } from 'aws-amplify/utils';
export default {
  name: "MainPage",
  data() {
    return {
      isUserInfoLoaded: false,
      isAuthorized: false,
      open: ["Users"],
      drawer: false,
      actions: [],
      action: "",
      confirmText: "",
      compoundNotice: "",
      confirmOverlay: false,
      confirmAction: false,
      allClear: false,
      url: "https://d3f8h5tcxf.execute-api.us-west-1.amazonaws.com/Prod/",
      payload: null,
      endpoint: "",
      method: "GET",
      notice: false,
      noticeText: "",
      noticeColor: "red",
      finish: "",
      logNewBug: false,
      bugDescription: null,
      bugType: 'bug',
      supportRequestTypes: [
        { title: 'Bug', value: 'bug' },
        { title: 'Question', value: 'question' },
        { title: 'Access Request', value: 'access' },
        { title: 'Training Request', value: 'training' },
      ],
      environment: process.env.ENVIRONMENT,
    };
  },
  components: {
    Breadcrumbs,
    // DashboardView,
  },
  computed: {
    primaryNav(){
      return this.$store.getters.getprimaryNav;
    },
    
    isCurrentEntityLoaded(){
      return this.$store.getters.isCurrentEntityLoaded;
    },

    isAppReadyForUser(){
      if(this.$store.getters.getUserPermissions && this.$store.getters.getprimaryNav){
        return true;
      }
      return false;
      // return this.$store.getters.getUserPermissions ? true : false;
    },
    // isHome() {
    //   return this.$route.fullPath === "/";
    // },
    appNotice() {
      return this.$store.getters.getAppNotice || "";
    },
    itemsBeingLoaded() {
      let itemsBeingLoaded = this.$store.getters.getItemsBeingLoaded;
      if(itemsBeingLoaded){
        if (itemsBeingLoaded.length > 0) {
          return true;
        }
      }
      return false;
    },
  },
  async mounted() {
    console.log('MainPage mounted');
    Hub.listen('auth', async ({ payload: { event } }) => {
      if (event === "signedIn") {
        const homePage = await this.$store.dispatch("setupUser");
        this.$router.push(homePage);
      }
    });

    

    // this.$store.dispatch("logUserOut");
    
    const isUserLoggedInOnLoad = await this.$store.dispatch("isUserLoggedIn") ? true : false;
    if(!this.isAppReadyForUser && isUserLoggedInOnLoad){
      await this.$store.dispatch("setupUser");
    }

    this.$eventBus.on("nav", (path, props) => {
      this.nav(path, props);
    });
    this.$eventBus.on("entity-add", (evt) => {
      this.EventResponse(evt);
    });
    this.$eventBus.on("alert", (evt) => {
      this.ShowNotice(evt, "red");
    });
  },
  methods: {
    logState() {
      console.log(this.$store.state);
    },
    clearConsole() {
      console.clear();
    },
    nav(path, message) {
      if (this.$route.path != path) {
        var props = { path: path, props: message };
        this.$router.push(props);
      }
    },
    async logout() {
      this.$store.dispatch("logUserOut");
    },
    logBug() {
      this.logNewBug = true;
    },
    submitBug(){
      if(!this.bugDescription){
        let appNotice = {
          message: `Please describe your request.`,
          success: false,
        };
        this.$store.dispatch("createAppNotice", appNotice);
        return;
      }
      this.logNewBug = false;
      const bug = {
        type: this.bugType,
        description: this.bugDescription,
        route: {
          path: this.$route.path,
          name: this.$route.name,
          params: this.$route.params,
          meta: this.$route.meta,
          href: this.$route.href,
          fullPath: this.$route.fullPath,
        },
        authInfo: {
          permissions: this.$store.state.authInfo.permissions,
          userSub: this.$store.state.authInfo.idToken.sub,
        },
      };
      this.bugDescription = null;
      this.bugType = 'bug';
      this.$store.dispatch("logBugToDB", bug);
    },
  },
  watch: {
    $route(to) {
      let payload = {
        view: to.name,
      };
      if(to.params.entity_id){
        payload.entityID = to.params.entity_id
      }
      if(to.fullPath === "/"){
        const primaryNav = this.$store.getters.getprimaryNav;
        console.log('primaryNav',primaryNav)
        if(primaryNav?.[0]?.url){
          var props = { path: primaryNav[0].url};
          this.$router.push(props);
        }
      }
    },
  }
};
</script>

<style>
main {
  overflow: scroll;
  background-color: #f2f5f7;
}
.v-container > .v-container {
  background-color: white;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.bottom .v-list-item-title {
  font-size: 12px;
}
* {
  box-sizing: border-box;
  font-family: Verdana, sans-serif;
}
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
  width: 100%;
}
#app {
  width: 100%;
  height: 100%;
}
.v-input__details {
    padding-left: 0 !important;
}
</style>
